<template>
   <header :class="headerClass">
    <div class="header__wrapper">
       <div class="container">
          <div class="row">
             <div class="col-12">
                <div class="header__block">
                      <NuxtLink  class="header__logo" :to="localePath('home')">
                         <img src="/static/images/default/logo-mbk-white.svg" loading="lazy" alt="mbk-logo-white">
                      </NuxtLink>
                      <NuxtLink  class="header__logo header__logo--sm" :to="localePath('home')">
                        <img src="/static/images/default/logo-mbk-group.svg" loading="lazy" alt="mbk-logo">
                      </NuxtLink>
                      <div class="header__detail">
                        <div class="header__menu">
                           <LayoutsMenusMain />
                        </div>
                        <!-- Search Icon -->
                        <div class="header__option">
                              <ul class="nav nav--option">
                                 <!-- <li class="nav-item nav-item--search">
                                    <a class="nav-link" :href="`/${locale}/search`">
                                    <i class="far fa-search"></i>
                                    </a>
                                 </li> -->
                                 <!-- Language Switcher - HTML Version -->
                                 <li class="nav-item nav-item--language">
                                    <div v-for="(lang, i) in locales" :key="i">
                                    <a :href="switchLocalePath(lang)" :class="lang == locale ? 'text-uppercase nav-link active' : 'text-uppercase nav-link'">{{ lang }}</a>
                                    </div>
                                 </li>
                              </ul>
                              <div class="header__icon">
                                 <div class="hamburger">
                                    <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#menuHamburger" aria-expanded="false">
                                       <div class="hamburger__wrapper">
                                          <div class="hamburger__line"></div>
                                          <div class="hamburger__line"></div>
                                          <div class="hamburger__line"></div>
                                       </div>
                                    </button>
                                 </div>
                              </div>
                        </div>
                       
                     </div>
                    
                </div>
               
             </div>
          </div>
       </div>
       <div class="header__hamburger">
            <LayoutsHamburger />
       </div>
    </div>
   </header>
 </template>
 
<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const { locale, locales, setLocale } = useI18n()

const switchLocalePath = useSwitchLocalePath()

const headerClass = ref('header')
const observer = ref(null);

const adjustMenuBackground = () => {
  if (window.innerWidth >= 1200) {
    document.querySelectorAll('.dropdown-menu--wrapper').forEach(wrapper => {
      const hasLv2ToggleShow = wrapper.querySelector('.dropdown-menu--lv2 .dropdown-toggle.show');
      const hasLv3Show = wrapper.querySelector('.dropdown-menu--lv3.show');
      
      if (hasLv2ToggleShow && hasLv3Show) {
        const lv2Width = 176;
        const lv3MinWidth = 311;
        const lv3ActualWidth = hasLv3Show.scrollWidth;
        const lv3Width = Math.max(lv3MinWidth, lv3ActualWidth);
        const totalWidth = lv2Width + lv3Width;
        
        wrapper.style.width = `${totalWidth}px`;
        wrapper.style.height = `${Math.max(wrapper.offsetHeight, hasLv3Show.offsetHeight)}px`;
      } else {
        wrapper.style.width = '176px';
        wrapper.style.height = 'auto';
      }
    });
  }
}
 
 const updateHeaderClass = () => {
   if (window.innerWidth < 1200) { 
      const hamburgerMenu = document.querySelector('#menuHamburger');
      if (hamburgerMenu) {
      headerClass.value = hamburgerMenu.classList.contains('show')
         ? 'header header--mobile'
         : 'header';
      console.log('Header class updated:', headerClass.value);
      }
   }else {
    headerClass.value = 'header';  
  }
 }
 
 onMounted(() => {
   const handleClick = () => {
     setTimeout(adjustMenuBackground, 100);
   };
   document.addEventListener('click', handleClick);

  const handleResize = () => {
    if (window.innerWidth < 1200) {
      document.querySelectorAll('.dropdown-menu--wrapper').forEach(wrapper => {
        wrapper.style.width = '';
        wrapper.style.height = '';
      });
    } else {
      adjustMenuBackground();
    }
    updateHeaderClass(); 
  };
  window.addEventListener('resize', handleResize);

  const navbarToggler = document.querySelector('.navbar-toggler')
  if (navbarToggler) {
    navbarToggler.addEventListener('click', updateHeaderClass)
  }

   const hamburgerMenu = document.querySelector('#menuHamburger');
   if (hamburgerMenu) {
      observer.value = new MutationObserver((mutations) => {
       mutations.forEach((mutation) => {
         if (mutation.attributeName === 'class') {
           updateHeaderClass();
         }
       });
     });

     observer.value.observe(hamburgerMenu, {
       attributes: true,
       attributeFilter: ['class']
     });
   }


   updateHeaderClass();

   onUnmounted(() => {
      const navbarToggler = document.querySelector('.navbar-toggler')
      if (navbarToggler) {
         navbarToggler.removeEventListener('click', updateHeaderClass)
      }
     document.removeEventListener('click', handleClick);
     window.removeEventListener('resize', adjustMenuBackground);

     if (observer.value) {
         observer.value.disconnect();
      }
   });
 });
 </script>
 
 <style lang="scss" scoped>
    @import "@/assets/scss/app";
 
    @each $lang in $languages {
       html[lang="#{$lang}"] {
         .nav{
            &.nav--option{
                .nav-item {
                      .nav-link {
                         @include font-size("h4", $lang);
                         @include font-weight("medium", $lang);
                      }  
                   }
             }
          }
       }
    }

    .header {
       position: absolute;
       top: 0;
       left: 0;
       z-index: 1030;
       width: 100%;
 
       .header__logo{
          padding-right: 2rem;
 
          img{
             max-width: 100%;
             height: auto;
          }

          &.header__logo--sm{
            display: none;
          }
       }

       .header__wrapper{
          background: linear-gradient(180deg, rgba($black,0.40) 0%, rgba($black, 0.00) 100%);
       }
       .header__block{
          position: relative;
          z-index: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1rem 0;

          @include media-breakpoint-down(xl) {
            padding: 0.75rem 0;
          }
       }

       .header__option{
         display: flex;
         align-items: center;
       }

       .header__icon {
         display: none;
         @include transition();

         @include media-breakpoint-down(lg) {
               display: block;
         }
      }

       .header__hamburger {
         overflow-y: auto;
         max-height: 85vh;

         @include transition();
         @include media-breakpoint-up(xl) {
               display: none;
         }

         &.collapsing {
               @include transition();
         }
      }

      .header__detail{
         display: flex;
         align-items: center;
      }

      &.header--mobile{
         .header__wrapper{
            background: $lightgreen-1;
            border-radius: 0 0 24px 24px;
         }
         .header__logo{
            display: none;

               &.header__logo--sm{
                  display: block;
               }
         }

         .header__block{
            @include media-breakpoint-down(xl) {
               border-bottom: 1px solid $darkgreen-1;
               padding: 0.75rem 0;
            }
         }

         .nav{
            &.nav--option{
               .nav-item {
                  .nav-link {
                     color: $black;
                  }

                  &.nav-item--language{
                     &::before{
                        background-color: $black;
                     }
                  }
               }
            }
         }
      }

    }

  

    .nav{
      &.nav--option{
         .nav-item {
            position: relative;
            .nav-link {
               color: $white;
               padding: 8px 12px;
               @include hover-focus-active {
                  color: $green-2;
               }
            }

            &.nav-item--language{
               position: relative;
               display: flex;
               padding-left: 8px;

               .nav-link{
                  padding: 8px 7px;
                  
                  &.active{
                     color: $green-2;
                  }
               }

               &::before{
                  position: absolute;
                  content: " ";
                  background-color: $white;
                  width: 1px;
                  height: 14px;
                  left: 0;
                  top: -1px;
                  bottom: 0;
                  margin: auto;
               }
            }
      
            &.nav-item--search{
               i{
                  font-size: 16px;
               }
            }
                
          }
      }
    } 

    .hamburger{
         position: relative;
         width: 35px;
         height: 34px;
         background-color: $green-1;
         margin-left: 0.65rem;
         border-radius: 12px;
         display: flex;
         justify-content: center;
         @include transition();

         // @include media-breakpoint-down(sm) {
         //    width: 38px;
         //    height: 38px;
         //    margin-left: 0.30rem;
         // }

         .navbar-toggler {
        
            .hamburger__wrapper{
               display: block;

               .hamburger__line {
                  position: relative;
                  display: block;
                  height: 2px;
                  width: 22px;
                  margin: 4px 0;
                  background-color: $darkgreen;
                  @include transition(.5s);



                  &:nth-child(2) {
                     width: 18px;

                     &::before, &::after{
                        position: absolute;
                        content: "";
                        background-color: $darkgreen;
                        width: 18px;
                        height: 2px;
                        align-items: center;
                        position: absolute;
                        left: 0;
                        opacity: 0;
                        @include transition(.5s);
                        transform: unset;
                     
                     }
                  }
               }

               @include hover {
                  .hamburger__line {
                     &:nth-child(2) {
                        width: 22px;
                     }
                  }
               }
            }

            &:not(.collapsed) {
               .hamburger__line {
                  margin: 0; 
                  
                  &:nth-child(1) {
                     opacity: 0;
                  }

                  &:nth-child(2) {
                     background-color: transparent;
                        &::before{
                           transform: rotate(45deg);
                           width: 22px;
                           opacity: 1;
                        }
                        &::after{
                           transform: rotate(-45deg);
                           width: 22px;
                           opacity: 1;
                        }
                  }

                  &:nth-child(3) {
                     opacity: 0;
                  }
               }
            }
         }
   }
 
   
 </style>